import Phaser from 'phaser';

export class TextResizer {
  private offscreenText: Phaser.GameObjects.Text;
  private startingFontSize: number;

  constructor(
    scene: Phaser.Scene,
    parentContainer: Phaser.GameObjects.Container,
    textStyle: Phaser.Types.GameObjects.Text.TextStyle,
  ) {
    // Create a hidden off-screen text object
    this.offscreenText = scene.add.text(0, 0, '', textStyle);
    this.offscreenText.setVisible(false);
    this.startingFontSize = parseInt(textStyle.fontSize as string, 10) || 40;

    parentContainer.on('destroy', this.destroy, this);
  }

  // Calculates the font size that allows the text to fit within the given dimensions.
  public fitText(content: string, maxWidth: number, minFontSize = 10): number {
    this.offscreenText.setText(content);
    let fontSize = this.startingFontSize;

    for (; fontSize >= minFontSize; fontSize--) {
      this.offscreenText.setFontSize(fontSize);

      const bounds = this.offscreenText.getBounds();
      if (bounds.width <= maxWidth) {
        break; // Text fits
      }
    }

    if (fontSize < minFontSize) {
      console.warn('Text could not fit within the specified size at a reasonable font size.');
      fontSize = minFontSize;
    }

    return fontSize;
  }

  private destroy() {
    this.offscreenText.destroy();
  }
}
